import { useState } from "react";

// features/services/ServiceCard.jsx
export default function ServiceCard({ service, index = 0 }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <article className="animate-rise" style={{ animationDelay: `${index * 110}ms` }}>
      <button
        type="button"
        className={`service-flip-card ${flipped ? "is-flipped" : ""}`}
        onClick={() => setFlipped((prev) => !prev)}
        aria-pressed={flipped}
        aria-label={`${service.title} დეტალურად`}
      >
        <span className="service-flip-inner">
          <span className="service-flip-face premium-card flex h-full flex-col">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#e8f1ff] text-2xl dark:bg-[#203350]">
              {service.icon}
            </div>
            <h3 className="mt-4 text-xl font-semibold text-[#0f2748] dark:text-[#e5efff]">
              {service.title}
            </h3>
            <p className="mt-3 leading-7 text-[#4c6180] dark:text-[#b5c9e8]">
              {service.description}
            </p>
            <p className="mt-auto pt-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#5a7eaf] dark:text-[#95b6e5]">
              დააჭირე დეტალებისთვის
            </p>
          </span>

          <span className="service-flip-face service-flip-back premium-card flex h-full flex-col">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#5a7eaf] dark:text-[#95b6e5]">
              დეტალური ინფორმაცია
            </p>
            <h3 className="mt-3 text-xl font-semibold text-[#0f2748] dark:text-[#e5efff]">
              {service.title}
            </h3>
            <p className="mt-4 leading-7 text-[#4c6180] dark:text-[#b5c9e8]">
              {service.details}
            </p>
            <p className="mt-auto pt-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#5a7eaf] dark:text-[#95b6e5]">
              უკან დასაბრუნებლად დააჭირე
            </p>
          </span>
        </span>
      </button>
    </article>
  );
}
